import { render, staticRenderFns } from "./TheInterdepartmentalTransfersList.vue?vue&type=template&id=36738d9c&"
import script from "./TheInterdepartmentalTransfersList.vue?vue&type=script&lang=js&"
export * from "./TheInterdepartmentalTransfersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports